import React from "react";
import Hero from "../Components/NewHome/Hero";
import AboutUs from "../Components/NewHome/AboutUs";
import OrgansAffected from "../Components/NewHome/OrgansAffected";
import OrganVideos from "../Components/NewHome/OrganVideos.jsx";
import InfoCard from "../Components/NewHome/InfoCard.jsx";
import DiabetesHypertension from "../Components/NewHome/DiabetesHypertension/DiabetesHypertension.jsx";
import HypertensionFacts from "../Components/NewHome/HypertensionFacts.jsx";
import PatientTestimonial from "../Components/NewHome/PatientTestimonial.jsx";
import ContactUs from "../Components/NewHome/ContactUs/ContactUs.jsx";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import AboutHypertension from "../Components/FirstComponents/AboutHypertension.jsx";

const NewHome = () => {
  // Animation variants for staggered children
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="min-h-screen"
    >
      <Helmet>
        <title>Mission Organ Protection</title>
        <meta name="description" content="Mission Organ Protection is an initiative by Micro Labs Limited focusing on diabetes awareness and related healthcare solutions." />
      </Helmet>

      {/* Hero Section */}
      <motion.div variants={itemVariants}>
        <Hero />
      </motion.div>

      {/* About Us Section */}
      <motion.div variants={itemVariants}>
        <AboutUs />
      </motion.div>



      {/* Organs Affected Section */}
      <motion.div variants={itemVariants}>
        <OrgansAffected />
      </motion.div>

      {/* Info Card Section */}
      {/* <motion.div variants={itemVariants}>
        <InfoCard />
      </motion.div> */}

      {/* Organ Videos Section */}
      {/* <motion.div variants={itemVariants}>
        <OrganVideos />
      </motion.div> */}

      {/* Diabetes & Hypertension Section */}
      <motion.div variants={itemVariants}>
        <DiabetesHypertension />
      </motion.div>

      {/* Hypertension Facts Section */}
      <motion.div variants={itemVariants}>
        <HypertensionFacts />
      </motion.div>

      {/* Patient Testimonial Section */}
      <motion.div variants={itemVariants}>
        <PatientTestimonial />
      </motion.div>

      {/* Contact Us Section */}
      <motion.div variants={itemVariants}>
        <ContactUs />
      </motion.div>
    </motion.div>
  );
};

export default NewHome;
